export enum LANGS {
  EN = 'en',
  JA = 'ja',
}
